import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { changeStatus, onSetSelectedproductAttribute, selectProductAttributeState, setAction } from "../redux/slices/productAttributeSlice"
import { ProductAttributeAPI } from "../apis/ProductAttributeAPI"
import { ProductAttribute } from "../types/slices/productAttributesType"

export const useProductAttributeStore = () => {

    const dispatch = useDispatch()
    const { productAttributes, productAttributeSelected, status, action } = useSelector(selectProductAttributeState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getproductAttribute = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductAttributeAPI.getproductAttribute({search:search})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getproductAttributeByCompany = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductAttributeAPI.getproductAttributeByCompany({search:search, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createproductAttribute = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductAttributeAPI.createproductAttribute({...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const optimizatedproductAttribute = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductAttributeAPI.optimizatedproductAttribute({...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const editproductAttribute = async (idattribute: number, data: any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductAttributeAPI.editproductAttribute(idattribute, {...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const changeStatusproductAttribute = async (idattribute: number, data: any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductAttributeAPI.changeStatusproductAttribute(idattribute, data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deleteproductAttribute = async (idattribute: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductAttributeAPI.deleteproductAttribute(idattribute)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedStore = (store: ProductAttribute) => {
        try {
            dispatch(onSetSelectedproductAttribute(store))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionAttribute = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        //states
        productAttributes,
        productAttributeSelected,
        status,
        action,
        //actions
        getproductAttribute,
        getproductAttributeByCompany,
        createproductAttribute,
        optimizatedproductAttribute,
        editproductAttribute,
        changeStatusproductAttribute,
        deleteproductAttribute,
        setSelectedStore,
        setActionAttribute,
    }
}